export default __webpack_public_path__ + "static/Bowl-image-87493ee90977e26a161fedc61fe724d8.png";